<template>
  <div class="content">
    <h1>Impressum</h1>
    <p>
      Angaben gemäß §5 TMG:
    </p>
    <p><small>ConfCloud.de ist ein Angebot von:</small></p>
    <p>
      <strong>Florian Freund Webentwicklung</strong><br />
      Im Wolfischbühl 33/4<br />79585 Steinen
    </p>
    <p>
      E-Mail:
      <a href="mailto:kontakt@florianfreundwebentwicklung.de"
        >kontakt@florianfreundwebentwicklung.de</a
      ><br />
      Telefon: 07627 5418663<br />
      Webseite:
      <a href="//florianfreundwebentwicklung.de"
        >florianfreundwebentwicklung.de</a
      >
    </p>
    <p>
      USt-ID: DE323526891
    </p>
    <p>
      Inhaltlich verantwortlich gemäß<br />
      § 55 Absatz 2 RStV: Florian Freund
    </p>
    <p>
      Information zur außergerichtlichen Online-Streitbeilegung gemäß Art. 14
      Abs. 1 ODR-VO: Florian Freund Webentwicklung nimmt nicht an einem
      Streitbeilegungsverfahren vor einer Verbraucher-schlichtungsstelle teil
      und ist hierzu auch nicht verpflichtet.
    </p>
  </div>
</template>

<script>
export default {
  name: "DocumentsImprint"
};
</script>

<style scoped lang="scss">
.document {
  max-width: 35rem;
  margin: 0 auto;
}
</style>
